<template>
  <div class="wikiUnitSearch" :class="{'active': visibleStatus}" @click.stop="">
    <div class="contentWrap">
      <div class="title">
        <h1>유닛 프로토콜 검색</h1>
        <div class="searchInput ">
          <input ref="search" type="text" v-model="searchText" @keydown.enter="getData">
          <button @click="getData"></button>
        </div>
      </div>
      <div class="results content">
        <ul v-if="results && results.length !== 0" class="list">
          <li v-for="item in results">
            <h3 class="title">{{ item.name }}
              <span>{{ item.createdDate }} | {{ item.userName }}</span>
            </h3>
            <!-- <span class="type">타입</span> -->
            <!-- <div class="desc" v-html="item.content"></div> -->
            <div class="desc" v-html="item.contentHtml"></div>
            <!-- <p class="desc">
              {{ item.shortsContent }}
            </p> -->
            <button class="add" @click="getUnit(item)">프로토콜 삽입</button>
          </li>
        </ul>
        <p v-else class="emptyResult">
          검색된 자료가 없습니다.
        </p>
      </div>
      <div class="ctrl">
        <Pagination ref="resultsCount" :pageCnt="pageNo+1" :pageTotalCnt="totalPage" :size="9" @click="selectPage" />
      </div>
      <button class="close" @click.stop="updateStatus({'unitProtocol': false})">닫기</button>
    </div>
    <Loading :visible="loading"></Loading>
  </div>
</template>

<script>
import {Editor, EditorContent, getText} from '@tiptap/vue-2'
import { Node, mergeAttributes  } from '@tiptap/core'
import { Color } from '@tiptap/extension-color'
import Document from '@tiptap/extension-document'
import Paragraph from '@tiptap/extension-paragraph'
import StarterKit from "@tiptap/starter-kit";
import Text from '@tiptap/extension-text'
import TextStyle from '@tiptap/extension-text-style'
import Highlight from '@tiptap/extension-highlight'
import Underline from '@tiptap/extension-underline'
import Strike from '@tiptap/extension-strike'
import Superscript from '@tiptap/extension-superscript'
import Subscript from '@tiptap/extension-subscript'
import TextAlign from '@tiptap/extension-text-align'
import Image from '@tiptap/extension-image'
import FontFamily from '@tiptap/extension-font-family'
//Tiptap custom extension
import FontSize from '../../mixins/tiptap/FontSize'
import Indent from '../../mixins/tiptap/Indent'

import axios from "axios";

import CommNew, {commNewMapMutations, commNewMapGetters} from "@processEditor/CommNew";
import Loading from '../common/loading.vue'
import LogListPopup from '../nav_process/Editor/comp/LogListPopup.vue'
import { indexOf } from 'lodash'
import Pagination from '@common/Pagination.vue'

const Div = Node.create({
	name: 'div',
	group:'block',
	content:'block*',
	renderHTML({ HTMLAttributes }) {
    return ['div', mergeAttributes(HTMLAttributes, {class:'unit-wrap', contenteditable: false}), 0]
  },
})

export default {
  name:'protocolUnitSearch',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  mixins: [CommNew],
  data() {
    return {
      results: [],
      visibleStatus: this.visible,
      searchText: '',
      textEditor: null,
      loading: false,
      pageNo: 0,
      totalPage: 0
    }
  },
  components: { Loading, Pagination,  },
  watch: {
    'status.unitProtocol': {
      async handler(value){
        this.visibleStatus = value;
        if(value === true) {
          setTimeout(()=>this.$refs.search.focus() , 10)
        }
      }
    }
  },
  mounted(){
    this.textEditor = new Editor({
				// content: data,
				editable: false,
				extensions: [ 
					StarterKit, 
					// Document, Paragraph, Text,  Strike,
					Div.configure({
						HTMLAttributes:{
							class: 'unit-wrap'
						},
					}),
					Indent.configure({
						types: ["heading", "paragraph"],
						indentLevels: [0, 30],
						defaultIndentLevel: 0,
					}),
					Color,  TextStyle, 
					Highlight.configure({ multicolor: true }), Underline,
					Superscript, Subscript,
					FontFamily, FontSize,
					TextAlign.configure({
						types: ['heading', 'paragraph'],
					}),
					Image.configure({
						allowBase64: true
					})
				],
			})
  }, 
  methods: {
    ...commNewMapMutations(['updateStatus']),
    async getData() {
      this.loading = true;
      // const res = await axios.get(
      //   // 'http://101.101.209.16:8079/api/v1/protocol/unitProtocol?query=%EA%B3%B5%EC%A0%95%EB%8F%84',
      //   `http://101.101.209.16:8079/api/v1/protocol/unitProtocol?query=${this.searchText}`,
      // )
      const res = await this.$wApi.protocol.unit.get({
        query: this.searchText,
        pageNo: this.pageNo,
        perPage: 9
      })
      // const res = await this.$wApi.protocol.unit.get({
      //   query:this.searchText
      // });
      this.totalPage = res.totalPages
      this.loading = false;
      const contents = res.content;
      let textList = [];
      // content를 tiptap을 이용하여 변환 후 html로 출력
      for(let item of contents) {
        // item.content = JSON.parse(item.content)
        // this.textEditor.commands.insertContent(
        //   item.contentHTML
        // )
        // item.contentHtml = this.textEditor.getHTML()
        item.contentHtml = item.content.replace(/^"(.*)"$/,'$1');
        item.contentHtml = item.contentHtml.replace(/\\"/gi, '"');
        item.contentHtml = item.contentHtml.replace(/\\n/gi, '');
        item.contentHtml = this.findText(item.contentHtml, this.searchText);
      }
      this.results = contents
      return textList
    },
    getUnit(item) {
      // if(typeof item.content == 'string') {
      //   item.content = JSON.parse(item.content)
      // }
      this.$emit('getUnit', item);
      this.updateStatus({'unitProtocol': false});
      // this.visibleStatus = false;
    },
    findText( content, targetText) {
      let texts = [];
      
      let rex = new RegExp(`<[^>]*>([^<]*(?:${targetText})[^<]*)<\/[^>]*>`,'g');
      texts = content.match(rex);

      texts = texts.flatMap(text => {
        let re = new RegExp(`${targetText}`,'gi');  
        text = text.replace(re, `<strong style="color:#67A1E3">${targetText}</strong>`);
        return text;
      })
      return texts.reduce( (acc, cur)=>{
        return `${acc} <p class="shortContent">${cur}<p/>`
      } ,'');
    } ,
    selectPage(pageNum) {
      this.pageNo = pageNum;
      this.getData()
    }
  }
}

</script>

<style lang="scss" scoped>
  .wikiUnitSearch {
    @include modalLayoutBlur();
    z-index: 99;
    .contentWrap {
      max-width: 1000px; min-width: 800px;
    }
    .title {
      gap: 0 16px;
      h1 {
        display: flex; align-items: center;
        font-size: 20px;
      }
      .searchInput {
        display: flex; align-items: center;
        border: 1px solid #999;
        border-radius: 5px;
        input {
          flex-shrink: 0;
          min-width: 400px; height: 32px;
          padding: 8px 16px;
          background: none;
          border: none;
        }
        button {
          flex-shrink: 0;
          width: 32px; height: 32px;
          margin-right: 5px;
          background: url('../../assets/icons/magnify.svg') center no-repeat;
          background-size: 16px 16px;
        }
      }
    }
    .results {
      min-height: 500px;
      padding: 16px 0; 
      border-top: 1px solid #333;
      .list {
        margin-top: 24px;
        li {
          display: flex; flex-direction: column;
          padding: 16px;
          color: #666;
          .title {
            display: block;
            font-size: 16px;
            @include text-prt-sb;
            span {
              display: block;
              margin-top: 8px;
              font-size: 14px;
              color: #666;
            }
          }
          .type{
            display: none;
          }
          .desc {
            margin-top: 16px;
            line-height: 1.5em;
            font-size: 16px;
          }
          button.add {
            visibility: hidden;
            min-height: 33px;
            padding: 8px 18px;
            border-radius: 5px;
            margin: 16px 0px 0px auto;
            background-color: #333;
            color: #fff;
            font-size: 14px;
            @include text-prt-sb;
          }
          &:hover {
            button.add { visibility: visible; }
          }
        }
        li:nth-child(even) {
          background-color: #F5F5F5;
        }
      }
    }
    .emptyResult {
      display: flex; align-items: center; justify-content: center;
      min-height: 400px;
      font-size: 16px;
      @include text-prt-sb;
    }
    .ctrl {
      padding: 15px 8px;
    }
  }
</style>
<style lang="scss">
  .unit-wrap {
    padding: 16px 16px;
    margin: 16px 0;
    background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='3' ry='3' stroke='%2367A1E3' stroke-width='2' stroke-dasharray='8%2c 16' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e");
    border-radius: 3px;
  }
  .shortContent {
    &:after {
      content: '...';
      display: block;
      width: 5px;
      word-break: break-all;
    }
    .findText {
      color: #67A1E3;
      font-weight: 700;
    }
  }
</style>